// EWM-544 — decides whether a candidate navigation should show the top loading
// bar. The bar is for *page* navigations only: it must NOT appear for
// same-page query-only changes (PLP filters / sort / pagination all push the
// same pathname with new search params) or hash jumps, and not for external
// links (the browser owns those). A change of pathname on the same origin is a
// real page navigation.
export const isPageNavigation = (currentUrl: string, nextHref: string): boolean => {
  try {
    const current = new URL(currentUrl);
    const next = new URL(nextHref, currentUrl);
    if (next.origin !== current.origin) return false;
    return next.pathname !== current.pathname;
  } catch {
    // Non-navigational hrefs (javascript:, mailto:, tel:, malformed) never trigger.
    return false;
  }
};
